import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { Context } from '../../..';
import { dropdownMenu } from '../../../routes';
import { urlLE } from '../../../appConfig';

const UserMenu: FC = () => {
  const { store } = useContext(Context);
  const location = useLocation();

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  // Интерактивная карта — открываем внешнее приложение
  const toSocObj = () => {
    window.location.href = 'https://inkarta.rcdo02.ru/';
  };

  const toMonitoring = () => {
    window.location.href = urlLE + 'map/#/veqsgbwajqivbnyyyrmp';
  };

  const toHappy59 = () => {
    window.open('https://help.happy59.com/', '_blank', 'noopener,noreferrer');
  };

  const socialMapTitle =
    store.lang === 'ba'
      ? 'Социаль объекттарҙың интерактив картаһы'
      : store.lang === 'ru'
      ? 'Интерактивная карта социальных объектов'
      : 'Interactive Map of Social Facilities';

  return (
    <div className="mx-0 btn-group-vertical left-menu-btn border-white">
      <Nav.Link as={Link} to="/" className="nav-link">
        <span className={'user-menu-text' + (isActive('/') ? ' active' : '')}>
          <Trans>Events</Trans>
        </span>
      </Nav.Link>

      <Nav className="user-menu-text">
        <NavDropdown
          title={
            store.lang === 'ba'
              ? 'Эшкә урынлашыу'
              : store.lang === 'ru'
              ? 'Трудоустройство'
              : 'Employment'
          }
          id="employment-dropdown"
          drop="end"
          menuVariant="dark"
        >
          {window.innerWidth > 480 ? (
            <NavDropdown.Item
              as={Link}
              to="/professions-atlas"
              eventKey="1"
              className="text-light p-0 m-0 nav-link"
            >
              <Trans>Atlas of professions</Trans>
            </NavDropdown.Item>
          ) : (
            <NavDropdown.Item
              href="https://atlas100.ru/catalog/"
              target="_blank"
              rel="noreferrer"
              eventKey="1"
            >
              <Trans>Atlas of professions</Trans>
            </NavDropdown.Item>
          )}
          <NavDropdown.Divider />
          <NavDropdown.Item
            href="https://careertest.ru/tests/opredelenie-professionalnyh-sklonnostej/"
            target="_blank"
            rel="noreferrer"
            eventKey="2"
          >
            <Trans>Professional testing</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item
            href="https://testometrika.com/business/test-to-determine-career/"
            target="_blank"
            rel="noreferrer"
            eventKey="3"
          >
            <Trans>Career guidance</Trans>
          </NavDropdown.Item>
        </NavDropdown>
      </Nav>

      {dropdownMenu.map((item, i) => (
        <Nav.Link key={i} as={Link} to={item.path} className="nav-link">
          <span className={'user-menu-text' + (isActive(item.path) ? ' active' : '')}>
            {item.title}
          </span>
        </Nav.Link>
      ))}

      {window.innerWidth > 480 ? (
        <Nav.Link as={Link} to="/answer-question" className="nav-link">
          <span className={'user-menu-text' + (isActive('/answer-question') ? ' active' : '')}>
            <Trans>Answer-Question</Trans>
          </span>
        </Nav.Link>
      ) : (
        <Nav.Link as="span" className="nav-link" onClick={toHappy59}>
          <span className="user-menu-text">
            <Trans>Answer-Question</Trans>
          </span>
        </Nav.Link>
      )}

      {store.user.is_staff ? (
        <Nav className="user-menu-text">
          <NavDropdown
            title={
              store.lang === 'ba' ? 'Конкурстар' : store.lang === 'ru' ? 'Конкурсы' : 'Competitions'
            }
            id="competitions-dropdown"
            drop="end"
            menuVariant="dark"
          >
            <NavDropdown.Item
              as={Link}
              to="/distant"
              eventKey="1"
              className="text-light p-0 m-0 nav-link"
            >
              <Trans>Distance Education Teacher</Trans>
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      ) : null}

      {/* Интерактивная карта — одиночный пункт */}
      <Nav.Link as="span" className="nav-link" onClick={toSocObj} role="button" tabIndex={0}>
        <span className="user-menu-text">{socialMapTitle}</span>
      </Nav.Link>

      {/* Мониторинги — один подпункт */}
      <Nav className="user-menu-text">
        <NavDropdown
          title={
            store.lang === 'ba'
              ? 'Мониторинг, отчет'
              : store.lang === 'ru'
              ? 'Мониторинги, отчеты'
              : 'Monitorings, reports'
          }
          id="monitoring-dropdown"
          drop="end"
          menuVariant="dark"
        >
          <NavDropdown.Item eventKey="1" onClick={toMonitoring}>
            <Trans>Monitorings, reports</Trans>
          </NavDropdown.Item>
        </NavDropdown>
      </Nav>

      {/* ПОЛЕЗНЫЕ ССЫЛКИ */}
      <Nav className="user-menu-text">
        <NavDropdown
          title={
            store.lang === 'ba'
              ? 'Файҙалы һылтанмалар'
              : store.lang === 'ru'
              ? 'Полезные ссылки'
              : 'Useful links'
          }
          id="links-dropdown"
          drop="end"
          menuVariant="dark"
        >
          <NavDropdown.Item href="https://edu.gov.ru/" target="_blank" rel="noreferrer" eventKey="1">
            <Trans>Ministry of Education of the Russian Federation</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://ikp-rao.ru/" target="_blank" rel="noreferrer" eventKey="2">
            <Trans>Institute of Correctional Pedagogy  of the</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item
            href="https://education.bashkortostan.ru/"
            target="_blank"
            rel="noreferrer"
            eventKey="3"
          >
            <Trans>Ministry of Education of the RB</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://irorb.ru/" target="_blank" rel="noreferrer" eventKey="4">
            <Trans>Institute of Education Development of the RB</Trans>
          </NavDropdown.Item>

          <NavDropdown.Divider />

          <NavDropdown.Item
            href="https://xn--90aivcdt6dxbc.xn--p1ai/"
            target="_blank"
            rel="noreferrer"
            eventKey="5"
          >
            ОБЪЯСНЯЕМ.РФ
          </NavDropdown.Item>
          <NavDropdown.Item href="http://pravo.gov.ru/" target="_blank" rel="noreferrer" eventKey="6">
            <Trans>Official Internet portal of legal information</Trans>
          </NavDropdown.Item>

          {/* внутренний маршрут */}
          <NavDropdown.Item as={Link} to="/asd-organizations" eventKey="7" className="text-light">
            <Trans>Organizations that help children with</Trans>
          </NavDropdown.Item>

          <NavDropdown.Divider />

          {/* Родительские организации */}
          <NavDropdown.Item href="https://autism-ufa.ru/" target="_blank" rel="noreferrer" eventKey="8">
            <Trans>ANO "RASSVET"</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://prodobro.02edu.ru/" target="_blank" rel="noreferrer" eventKey="9">
            <Trans>MAOU "City Center ProDobro", Ufa</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://roosd.ru/" target="_blank" rel="noreferrer" eventKey="10">
            <Trans>Regional parents’ organization of children with disabilities of the RB</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://сияниечистогоразума.рф/" target="_blank" rel="noreferrer" eventKey="11">
            <Trans>ANO "Clear Mind" (adaptive & inclusive programs for people with ASD)</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://vk.com/materinskoe_serdce" target="_blank" rel="noreferrer" eventKey="12">
            <Trans>Council of Mothers "Materinskoe Serdce" of the RB</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://fond-marhamat.ru/" target="_blank" rel="noreferrer" eventKey="13">
            <Trans>Charitable Educational Foundation "Markhamat"</Trans>
          </NavDropdown.Item>

          {/* НОВЫЕ: Центры ментального здоровья */}
          <NavDropdown.Divider />

          <NavDropdown.Item href="https://rpmpk-ufa.ru" target="_blank" rel="noreferrer" eventKey="14">
            <Trans>Mental Health Center (RCPPMCP) — Ufa</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://cmz.rpbmzrb.ru/" target="_blank" rel="noreferrer" eventKey="15">
            <Trans>Mental Health Center (RCPB)</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://frc-tmnr.pskov.ru" target="_blank" rel="noreferrer" eventKey="16">
            <Trans>Mental Health Center — FRC TMNR</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://www.inclusive-edu.ru" target="_blank" rel="noreferrer" eventKey="17">
            <Trans>Mental Health Center — FCIO</Trans>
          </NavDropdown.Item>
          <NavDropdown.Item href="https://autism-frc.ru" target="_blank" rel="noreferrer" eventKey="18">
            <Trans>Mental Health Center — FRC ASD</Trans>
          </NavDropdown.Item>
        </NavDropdown>
      </Nav>

      {store.user.is_staff ? (
        <Nav className="user-menu-text">
          <NavDropdown
            title={store.lang === 'ba' ? 'Һорауҙар' : store.lang === 'ru' ? 'Вопросы' : 'Questions'}
            id="questions-dropdown"
            drop="end"
            menuVariant="dark"
          >
            <NavDropdown.Item
              as={Link}
              to="/my_questions"
              eventKey="1"
              className="text-light p-0 m-0 nav-link"
            >
              <Trans>My questions</Trans>
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to="/questions_to_me"
              eventKey="2"
              className="text-light p-0 m-0 nav-link"
            >
              <Trans>Questions to me</Trans>
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      ) : null}

      {store.user.is_active && !store.user.is_staff ? (
        <Nav.Link as={Link} to="/my_questions" className="nav-link">
          <span className={'user-menu-text' + (isActive('/my_questions') ? ' active' : '')}>
            <Trans>My questions</Trans>
          </span>
        </Nav.Link>
      ) : null}

      <Nav.Link as={Link} to="/ask" className="nav-link">
        <span className={'user-menu-text' + (isActive('/ask') ? ' active' : '')}>
          <Trans>Ask a question</Trans>
        </span>
      </Nav.Link>

      {store.user.is_staff ? (
        <Nav.Link as={Link} to="/settingsforspecialist" className="nav-link">
          <span
            className={
              'min-letter-spacing user-menu-text' +
              (isActive('/settingsforspecialist') ? ' active' : '')
            }
          >
            <i className="icon admin" />
            <Trans>Administration</Trans>
          </span>
        </Nav.Link>
      ) : null}
    </div>
  );
};

export default observer(UserMenu);
